// Themes.tsx
import { createTheme } from "@mui/material/styles";

const Theme = createTheme({
  components: {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
          "&:hover": {
            backgroundColor: "#f5f5f5",
          },
          "&.Mui-focused": {
            backgroundColor: "white",
          },
          "&::after": {
            borderBottom: "2px solid #56828C", // Focus çizgi rengi
          },
          "&::before": {
            borderBottom: "1px solid #cccccc", // Normal çizgi rengi
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#56828C",
          "&.Mui-focused": {
            color: "#56828C",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& fieldset": {
            borderColor: "#A6A6A6", // Kenarlık rengi
          },
          "&:hover fieldset": {
            borderColor: "#868686", // Hover kenarlık rengi
          },
          "&.Mui-focused fieldset": {
            borderColor: "#56828C", // Focus kenarlık rengi
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#395359",
          color: "white",
          "&:hover": {
            backgroundColor: "#2a3f43",
          },
          "&:disabled": {
            backgroundColor: "#ccc",
            color: "#888",
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#A6A6A6",
          color: "black",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: "#A6A6A6",
          color: "black",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#56828C", // Alt çizgi rengi
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: "#A6A6A6", // Varsayılan metin rengi
          "&.Mui-selected": {
            color: "#56828C", // Seçili renk
            fontWeight: "bold", // Kalın metin
          },
          fontSize: "1rem", // Varsayılan font boyutu
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          color: "#56828C", // Varsayılan metin rengi
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          "&:focus": {
            outline: "none", // Mavi odak çerçevesini kaldırır
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#56828C", // Özel odak kenarlık rengi
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#56828C", // Seçili öğenin arka plan rengi
            color: "white", // Seçili öğenin yazı rengi
            fontWeight: "bold", // Seçili öğe kalın yazı
          },
          "&.Mui-selected:hover": {
            backgroundColor: "#466b78", // Hover durumundaki arka plan rengi
            color: "white", // Hover durumundaki yazı rengi
          },
          "&:hover": {
            backgroundColor: "#f5f5f5", // Hover (seçili değilken) arka plan rengi
          },
        },
      },
    },
  },
});

export default Theme;
